import axios from "axios";
import { EMAIL_API_URL } from "../../config/constants";

/*********************************************************
* Function Name : sendWelcomeMail
* Description   : used to send welcome mail to all users
* By            : Sumit Bedwal
* Date          : 04-03-2024 
*********************************************************/
export const sendWelcomeMail = async (options) =>{
    // console.log('options--',options);
    try{
        const url = `${EMAIL_API_URL}/registration`;
        const headers = { 'Authorization' : 'KztpEM93Xq25ubxhFLHdsT4raVYJPBckygAn68U7' };
        return await axios.post(url, options, { headers });
    } catch(error){
        return error;
    }
};//End of Function


/*********************************************************
* Function Name : sendCompanyBroadcastMail
* Description   : used to send company broadcast email to all investors
* By            : Sumit Bedwal
* Date          : 04-03-2024 
*********************************************************/
export const sendCompanyBroadcastMail = async (options) =>{
    // console.log('company broad cast options--',options);
    try{
        const url = `${EMAIL_API_URL}/newcompanyaddedbroadcast`;
        const headers = { 
                'Authorization' : 'KztpEM93Xq25ubxhFLHdsT4raVYJPBckygAn68U7',
                'Content-Type'  :  'application/json'
            };
        // return await axios.post(url, options, { headers });
        return true;
    } catch(error){
        return error;
    }
};//End of Function


/*********************************************************
* Function Name : sendEventBroadcastMail
* Description   : used to send event broadcast email to all users
* By            : Sumit Bedwal
* Date          : 04-03-2024 
*********************************************************/
export const sendEventBroadcastMail = async (options) =>{
    // console.log('event broadcast options--',options);
    try{
        const url = `${EMAIL_API_URL}/eventbroadcast`;
        const headers = { 
                'Authorization' : 'KztpEM93Xq25ubxhFLHdsT4raVYJPBckygAn68U7',
                'Content-Type'  :  'application/json'
            };
        // return await axios.post(url, options, { headers });
        return true;
    } catch(error){
        return error;
    }
};//End of Function



/*********************************************************
* Function Name : sendWelcomeMail
* Description   : used to send welcome mail to users
* By            : Sumit Bedwal
* Date          : 04-03-2024 
*********************************************************/
export const sendMeetingCancelledMail = async (options) =>{
    // console.log('meeting cancelled options--',options);
    try{
        const url = `${EMAIL_API_URL}/meetingcancelled`;
        const headers = { 
                'Authorization' : 'KztpEM93Xq25ubxhFLHdsT4raVYJPBckygAn68U7',
                'Content-Type'  :  'application/json'
            };
        // return await axios.post(url, options, { headers });
        return true;
    } catch(error){
        return error;
    }
};//End of Function


/*********************************************************
* Function Name : sendWelcomeMail
* Description   : used to send welcome mail to users
* By            : Sumit Bedwal
* Date          : 04-03-2024 
*********************************************************/
export const sendMeetingScheduleMail = async (eventMode) =>{
    console.log('inside sendMeetingScheduleMail');

    const options = {
        send: "yes",
        mode: eventMode
    }
    console.log('options',options);
    try{
        let url = "";
        if(eventMode === 'test'){
            url = `https://chiratae.primeapps.co.in/apiv2/sendmail/schedulesenddev`;
        } else if(eventMode === 'prod'){
            url = `https://chiratae.primeapps.co.in/apiv2/sendmail/schedulesendprod`;
        } else {
            console.log('inside else--');
            url = `https://chiratae.primeapps.co.in/apiv2/sendmail/schedulesenddev`;
        }
        console.log('url',url);
        // const url = `${EMAIL_API_URL}/schedulesend`;
        const headers = { 
                'Authorization' : 'KztpEM93Xq25ubxhFLHdsT4raVYJPBckygAn68U7',
                'Content-Type'  :  'application/json'
            };
        return await axios.post(url, options, { headers });
        // return true;
    } catch(error){
        return error;
    }
};//End of Function

export const sendMeetSchedRMDetailsInvestorOnlyMail = async (eventMode) =>{
    console.log('inside sendMeetSchedRMDetailsInvestorOnlyMail---->');
    // return true;

    const options = {
        send: "yes",
        mode: eventMode
    }
    console.log('options---->',options);
    console.log('eventMode---->',eventMode);

    try{
        let url = "";
        if(eventMode === 'test'){
            url = `https://chiratae.primeapps.co.in/apiv2/sendmail/schedulesenddevrminvestoronly`;
        } else if(eventMode === 'prod'){
            url = `https://chiratae.primeapps.co.in/apiv2/sendmail/schedulesendprodrminvestoronly`;
        } else {
            console.log('inside else--');
            url = `https://chiratae.primeapps.co.in/apiv2/sendmail/schedulesenddevrminvestoronly`;
        }
        // url = `https://chiratae.primeapps.co.in/apiv2/sendmail/schedulesenddevrminvestoronly`;
        console.log('url---->',url);
        // const url = `${EMAIL_API_URL}/schedulesend`;
        const headers = { 
                'Authorization' : 'KztpEM93Xq25ubxhFLHdsT4raVYJPBckygAn68U7',
                'Content-Type'  :  'application/json'
            };
        return await axios.post(url, options, { headers });
        // return true;
    } catch(error){
        return error;
    }
};//End of Function





/////////////////////////////////////////////// 2025 //////////////////////////////////////////////////////////
/*********************************************************
* Function Name : sendInvestorInviteMail
* Description   : used to send company broadcast email to all investors
* By            : Sumit Bedwal
* Date          : 13-08-2025 
*********************************************************/
export const sendInvestorInviteMail = async (options) =>{
    // console.log('company broad cast options--',options);
    try{
        const url = `${EMAIL_API_URL}/investorinvite`;
        const headers = { 
                'Authorization' : 'KztpEM93Xq25ubxhFLHdsT4raVYJPBckygAn68U7',
                'Content-Type'  :  'application/x-www-form-urlencoded'
            };
        return await axios.post(url, options, { headers });
    } catch(error){
        return error;
    }
};//End of Function

/*********************************************************
* Function Name : sendWelcomeInvestorMail
* Description   : used to send welcome mail to all users
* By            : Sumit Bedwal
* Date          : 04-03-2024 
*********************************************************/
export const sendWelcomeInvestorMail = async (options) =>{
    try{
        const url = `${EMAIL_API_URL}/welcomeinvestor`;
        const headers = { 
                'Authorization' : 'KztpEM93Xq25ubxhFLHdsT4raVYJPBckygAn68U7',
                'Content-Type'  :  'application/x-www-form-urlencoded'
            };
        return await axios.post(url, options, { headers });
    } catch(error){
        return error;
    }
};//End of Function


/*********************************************************
* Function Name : sendWelcomeCompanyMail
* Description   : used to send welcome mail to all users
* By            : Sumit Bedwal
* Date          : 04-03-2024 
*********************************************************/
export const sendWelcomeCompanyMail = async (options) =>{
    try{
        const url = `${EMAIL_API_URL}/welcomecompany`;
        const headers = { 
                'Authorization' : 'KztpEM93Xq25ubxhFLHdsT4raVYJPBckygAn68U7',
                'Content-Type'  :  'application/x-www-form-urlencoded'
            };
        return await axios.post(url, options, { headers });
    } catch(error){
        return error;
    }
};//End of Function



/*********************************************************
* Function Name : sendCalendarInviteMailToInvestor
* Description   : used to send Event calendar invite mail to all investors
* By            : Sumit Bedwal
* Date          : 10-09-2025 
*********************************************************/
export const sendCalendarInviteMailToInvestor = async (options) =>{
    try{
        const url = `${EMAIL_API_URL}/investorcalenderics`;
        const headers = { 
                'Authorization' : 'KztpEM93Xq25ubxhFLHdsT4raVYJPBckygAn68U7',
                'Content-Type'  :  'application/x-www-form-urlencoded'
            };
        return await axios.post(url, options, { headers });
    } catch(error){
        return error;
    }
};//End of Function